import { IBridgeApplicationGridRecord } from '../mockData/mockApplicationsGridData';
import { ApplicationsGrid } from './components/ApplicationsGrid/ApplicationsGrid';
import { BridgeAppraisalStatusGroupSection } from './components/ApplicationsGrid/functions/mappers/bridgeAppraisalStatusGroupMapper';
import { useEffect, useState } from 'react';
import { HeaderBarActions } from './components/HeaderBarActions/HeaderBarActions';
import { ScopedWaitOverlay } from '@apply/components';

export interface ApplicationsProps {
    data: IBridgeApplicationGridRecord[] | undefined;
    set_headerActions: (actions: React.ReactNode) => void;
    isActive: boolean;
    isLoading: boolean;
}

export const Applications = ({ data, isActive, set_headerActions, isLoading }: ApplicationsProps) => {
    const [selectedGroup, set_selectedGroup] = useState<BridgeAppraisalStatusGroupSection | 'All'>('All');

    useEffect(() => {
        if (isActive) {
            set_headerActions(
                <HeaderBarActions
                    selectedGroup={selectedGroup}
                    set_selectedGroup={set_selectedGroup}
                />
            );
        }
    }, [set_headerActions, isActive, selectedGroup]);

    return (
        <>
            <div className='scrollable-content no-search'>
                <div>
                    <div>
                        <ApplicationsGrid
                            data={data}
                            selectedGroup={selectedGroup}
                        />
                    </div>
                </div>
            </div>
            <ScopedWaitOverlay
                visible={isLoading}
                label='Retrieving Bridge Applications...'
                mode='Admin'
            />
        </>
    );
};
